import gql from 'graphql-tag';

// When we decouple Chill bill from the Power page (especially the PowerPageChild type),
// we can limit the data coming from this query to only what we need
// Currently we fetch the exact same data as the Power page to be able to match the current
export const GetFinanceOverviewChildren = gql`
    query GetFinanceOverviewChildren($siteId: SiteId!, $childIds: [ChildId!]!) {
        finance {
            financeOverviewVersioned {
                v2 {
                    detachedFinanceOverviewChildren(siteId: $siteId, childIds: $childIds) {
                        child {
                            id
                            birthday
                            name {
                                fullName
                                firstName
                                middleName
                                lastName
                            }
                            profileImage {
                                url
                            }
                            group {
                                title
                            }
                            startDate
                            endDate
                        }
                        plans {
                            planId
                            range {
                                from
                                to
                            }
                            pricingGroup {
                                # If empty/null, automatic pricing groups/bands are used
                                title
                                pricingGroupId
                            }
                            # replaces pricingGroup in the case of automatic pricing groups/bands
                            ruleGroupId
                            parts {
                                planPartId
                                order # Only parts with order = 0 can have funding
                                termTimeOnly
                                statistics {
                                    sessionMinutesPerWeek
                                }
                                priceModifiers {
                                    title
                                }
                                billingScheme {
                                    id
                                    shortTitle
                                    title
                                }
                                attendanceSchedule {
                                    id
                                    title
                                    fullYear
                                }
                                billingProfile {
                                    billingProfileId
                                    title
                                    annualization {
                                        weeksOfCare
                                        invoices
                                    }
                                }
                                funding {
                                    method # ASSISTED, MANUAL or MANUAL_BY_RATE
                                    time {
                                        ... on PlanFundingTimeHours {
                                            hours
                                        }
                                        ... on PlanFundingTimeMinutes {
                                            minutes
                                        }
                                    }
                                    ... on PlanFundingManual {
                                        amount
                                    }
                                    ... on PlanFundingManualByRate {
                                        rate
                                    }
                                }
                                bookings {
                                    planId
                                    planPartId
                                    ... on PlanSessionBooking {
                                        sessionAvailability {
                                            session {
                                                sessionId
                                                pricing {
                                                    price
                                                    pricingGroupId
                                                }
                                                fundable
                                                title # Name of the session
                                                type # StandaloneSession or PackageSession
                                            }
                                            day
                                        }
                                        timeRange {
                                            from
                                            to
                                        }
                                    }
                                    ... on PlanProductBooking {
                                        amount
                                        productAvailability {
                                            product {
                                                productId
                                                title # Name of the product/extra charge
                                                pricing {
                                                    pricingGroupId
                                                    price
                                                }
                                            }
                                            day
                                        }
                                    }
                                }
                                priceModifiers {
                                    amount
                                    percent
                                    order
                                    showOnInvoice
                                    title
                                    ... on PlanPriceModifierDiscount {
                                        discountPresetId
                                        period
                                    }
                                    ... on PlanPriceModifierSurcharge {
                                        period
                                    }
                                }
                            }
                        }
                        billPayers {
                            billPayer {
                                name
                                billPayerId
                                email
                                phone
                            }
                            share
                            balance
                            billingFrequency
                            paymentMethods {
                                id
                                type
                                active
                                title
                            }
                            automaticPaymentMethodId
                            onAutomaticBilling
                            latestInvoice {
                                invoiceDate
                                total
                                invoiceId
                            }
                            nextInvoice
                            onAutomaticBilling
                        }
                    }
                }
            }
        }
    }
`;
